// /web/src/pages/Cookies.jsx
const lastUpdated = new Date().toISOString().slice(0, 10);

export default function CookiePolicy() {
  return (
    <section className="pd-blog prose">
      <header className="pd-blog__header">
        <p className="small" style={{ textTransform: "uppercase", letterSpacing: 0.4 }}>
          Last updated {lastUpdated}
        </p>
        <h1>Cookie Policy</h1>
        <p className="lead" style={{ marginTop: 0 }}>
          How Pebbledash uses cookies and similar technologies, and how you can manage your
          preferences.
        </p>
      </header>

      <article className="pd-blog__body">
        <p>
          Cookies are small text files that help us provide secure login, remember preferences and
          understand how the site is used. This policy explains the categories of cookies we use on
          pebbledash.co and the choices available to you.
        </p>

        <h2>Essential cookies</h2>
        <p>
          These cookies are required to operate the service. They support authentication, maintain
          your session and keep the application secure. Because they are necessary to deliver the
          product you request, they cannot be turned off.
        </p>
        <ul>
          <li><strong>Auth0</strong> – stores the tokens needed to sign you in.</li>
          <li><strong>Pebbledash</strong> – remembers in-app preferences such as calculator inputs.</li>
          <li><strong>Stripe</strong> – enables checkout and billing flows.</li>
        </ul>

        <h2>Analytics cookies (optional)</h2>
        <p>
          With your consent we enable privacy-friendly analytics via Amplitude. These tools help us
          understand feature adoption and improve Pebbledash. Analytics cookies are
          <strong>off by default</strong> and are only set once you opt in through the cookie banner
          or settings panel.
        </p>

        <h2>Marketing cookies</h2>
        <p>
          We do not currently set any marketing or advertising cookies. If that changes we will ask
          for explicit consent first and update this page.
        </p>

        <h2>Managing your preferences</h2>
        <p>
          You can change your cookie choices at any time. Use the “Cookie settings” button in the
          footer of any page to reopen the preferences panel, or clear cookies in your browser. Your
          selections are stored for one year unless you withdraw consent earlier.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy? Email us at{' '}
          <a href="mailto:info@pebbledash.co">info@pebbledash.co</a>.
        </p>
      </article>
    </section>
  );
}
